import {
    Container 
} from "./styles";
import GhostIcon from "icons/GhostIcon";

const NotificationNoContent = ({
    title, 
    description,
    variant = "primary",
    direction = "column",
    marginTop 
}) => {
    const getClassName = () => {
        return [variant, direction].join(" ");
    }
    return (
        <Container 
            className={getClassName()}
            marginTop={marginTop}>
            <GhostIcon/>
            {title && <h4>{title}</h4>}
            <p>{description}</p>
        </Container>
    );
}

export default NotificationNoContent;